import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { getEvaluationRoundLabel } from '@/utils/formatters';

interface AssessmentQualityRow {
  roundName: string;
  attempts: number;
  averageScore: number;
  medianScore: number;
  passRate: number;
}

interface AssessmentQualityInsightsProps {
  data: AssessmentQualityRow[];
}

export function AssessmentQualityInsights({ data }: AssessmentQualityInsightsProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Assessment Quality Insights</CardTitle>
        <CardDescription>
          Round-wise attempts, score quality, and pass rates for the selected year
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Round</TableHead>
              <TableHead className="text-right">Attempts</TableHead>
              <TableHead className="text-right">Average</TableHead>
              <TableHead className="text-right">Median</TableHead>
              <TableHead className="text-right">Pass Rate</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} className="text-center text-muted-foreground">
                  No assessment analytics available
                </TableCell>
              </TableRow>
            ) : (
              data.map((row) => (
                <TableRow key={row.roundName}>
                  <TableCell className="font-medium">
                    {getEvaluationRoundLabel(row.roundName as any)}
                  </TableCell>
                  <TableCell className="text-right">{row.attempts}</TableCell>
                  <TableCell className="text-right">{row.averageScore.toFixed(1)}</TableCell>
                  <TableCell className="text-right">{row.medianScore.toFixed(1)}</TableCell>
                  <TableCell className="text-right">{row.passRate.toFixed(1)}%</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
